var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.$isMobile() ? "100%" : "max-content" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "modal-invoice-details",
          attrs: { "background-color": "#f5f5f5", flat: "" },
        },
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary", dark: "", flat: "" } },
            [
              _c("v-toolbar-title", [_vm._v("DETALHES DA NOTA FISCAL")]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-card",
                { staticClass: "card-invoice", attrs: { flat: "" } },
                [
                  _c("v-card-text", { staticClass: "d-flex header-nf" }, [
                    _c("div", { staticClass: "mr-3 pr-3 info-nf" }, [
                      _vm._v("\n            NFe: "),
                      _c("b", [
                        _vm._v(_vm._s(_vm.detailsInformation.invoiceNumber)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-2" }, [
                        _vm._v("Série: "),
                        _c("b", [
                          _vm._v(_vm._s(_vm.detailsInformation.serialNumber)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "gray--text text--lighten-1" },
                        [_vm._v(_vm._s(_vm.detailsInformation.emitterName))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-nf ml-3" }, [
                      _c(
                        "span",
                        { staticClass: "gray--text text--lighten-1" },
                        [_vm._v("Vendedor")]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.detailsInformation.seller) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-nf mr-2 ml-3" }, [
                      _c(
                        "span",
                        { staticClass: "gray--text text--lighten-1" },
                        [_vm._v("Emissão")]
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$date(_vm.detailsInformation.issuedAt)) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "invoice-status" }, [
                      _c(
                        "span",
                        { staticClass: "gray--text text--lighten-1" },
                        [_vm._v("Total de itens: ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "status-icon" },
                        [
                          _c("v-icon", { staticClass: "green--text" }, [
                            _vm._v("verified"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "status-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getCountStatusItems.valid
                              ? _vm.getCountStatusItems.valid
                              : 0
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "status-icon ml-3" },
                        [
                          _c("v-icon", { staticClass: "orange--text" }, [
                            _vm._v("watch_later"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "status-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getCountStatusItems.pending
                              ? _vm.getCountStatusItems.pending
                              : 0
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "status-icon ml-3" },
                        [
                          _c("v-icon", { staticClass: "red--text" }, [
                            _vm._v("error"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "status-title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getCountStatusItems.rejected
                              ? _vm.getCountStatusItems.rejected
                              : 0
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("AppBody", {
                    attrs: { headers: _vm.headers, items: _vm.productsItems },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }